import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

export default function MPBody() {
  const history = useHistory();

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const categories = [
    {
      name: "haircut",
      image:
        "https://images.unsplash.com/photo-1622286342621-4bd786c2447c?w=400&h=300&fit=crop",
    },
    {
      name: "nails",
      image:
        "https://images.unsplash.com/photo-1604654894610-df63bc536371?w=400&h=300&fit=crop",
    },
    {
      name: "lashes",
      image:
        "https://images.unsplash.com/photo-1516975080664-ed2fc6a32937?w=400&h=300&fit=crop",
    },
  ];

  const handleCategoryClick = (categoryName) => {
    history.push(`/allcategories/${categoryName}`);
  };

  return (
    <div
      style={{
        width: "100%",
        //backgroundColor: "#f472b6",
        padding: "40px 20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: windowWidth > 768 ? "repeat(3, 1fr)" : "1fr",
          gap: "30px",
          maxWidth: "1200px",
          width: "100%",
        }}
      >
        {categories.map((category) => (
          <div
            key={category.name}
            onClick={() => handleCategoryClick(category.name)}
            style={{
              backgroundColor: "white",
              borderRadius: "5px",
              overflow: "hidden",
              cursor: "pointer",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)";
              e.currentTarget.style.boxShadow =
                "0 8px 12px rgba(0, 0, 0, 0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 4px 6px rgba(0, 0, 0, 0.1)";
            }}
          >
            <img
              src={category.image}
              alt={category.name}
              style={{
                width: "100%",
                height: "200px",
                objectFit: "cover",
              }}
            />
            <div
              style={{
                padding: "20px",
                textAlign: "center",
              }}
            >
              <h3
                style={{
                  margin: 0,
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#333",
                  textTransform: "capitalize",
                }}
              >
                {category.name}
              </h3>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
